import * as React from 'react';
import styles from './message-to-user.scss';
import { createFormatters, parseAsDateUTC } from 'app/infrastructure/data/date';
import { containerFactory } from 'app/infrastructure/redux';
import * as shellActions from 'app/shell/default/actions';
import { messagesToUserTranslation, messageStatusOptions } from 'app/shell/constants';
import { STATE } from 'app/constants';
import { MessageToUser } from 'app/shell/components/messages-to-user/message-to-user';
import { MessagesToUserProps } from './types';

enum VisibilityState {
  visible = 'visible',
  hidden = 'hidden'
}
export class MessagesToUserComponent extends React.PureComponent<MessagesToUserProps> {
  public static statePath: string = STATE.app;
  private formatters: any;
  private interval: any;

  constructor(props: MessagesToUserProps) {
    super(props);
    this.formatters = createFormatters(props.locale);
  }

  public static defaultProps: Partial<MessagesToUserProps> = {
    interval: 15 * 60 * 1000
  };

  private onGetMessages = () => {
    const { getMessagesToUser } = this.props;
    if (document.visibilityState === VisibilityState.visible && getMessagesToUser) {
      getMessagesToUser();
    }

    this.interval = setTimeout(this.onGetMessages, this.props.interval);
  };

  public componentDidMount() {
    this.onGetMessages();
  }

  public componentWillUnmount() {
    this.interval && clearTimeout(this.interval);
  }

  private dateFormatter = (date: string) => this.formatters.formatDate(parseAsDateUTC(date), {
    weekday: 'long', day: 'numeric', month: 'long', year: 'numeric'
  });

  public render() {
    const { translation, messagesToUser, showUnreadMessagesOnly, wrapper, showNoItemsMessage } = this.props;

    const messages = messagesToUser.filter(({status}) => status.v === messageStatusOptions.unread === !!showUnreadMessagesOnly);
    if (messages.length === 0) {
      return !showNoItemsMessage ? null : (
        showUnreadMessagesOnly ? translation.no_unread_messages : translation.no_read_messages
      );
    }

    const messageComponents = messages.map((message) =>
      <MessageToUser key={message.id} messageId={message.id}
        messageSubject={message.subject} messageDate={this.dateFormatter(message.messageDate)}
        messageText={message.message} messageStatus={message.status.v} textMarkAsRead={translation.mark_as_read}
        textMarkAsUnread={translation.mark_as_unread} updating={message.updating} dateLabel={translation.message_date}
        {...this.props} />);

    return wrapper ? wrapper(messageComponents) : messageComponents;
  }
}

const wrapInMainGrid: React.FC<React.PropsWithChildren<any>> = (component: any) =>
  <div className={`container main-grid ${styles.unreadContainer}`}>
    {component}
  </div>;

export const MessagesToUserUnread = (props: MessagesToUserProps) => {
  return <MessagesToUserComponent showUnreadMessagesOnly={true} wrapper={wrapInMainGrid} {...props} />;
};

const container = containerFactory<MessagesToUserProps>(
  MessagesToUserComponent,
  shellActions.actionCreators,
  {},
  messagesToUserTranslation
);

export { container as MessagesToUser };
